<script setup lang="ts">
import LoyaltyCreateContainer from './LoyaltyCreateContainer.vue'
import LoyaltyCreateGradientCard from './LoyaltyCreateGradientCard.vue'
const router = useRouter()
const route = useRoute()
const { t } = useI18n()

const { goToStep, handleLoyaltyClick } = useLoyalty()
const { send } = useEvent()

const handleClick = async (type: 'tablet' | 'hardwareless') => {
  await router.push({ query: { ...route.query, type: type } })

  if (type === 'tablet') {
    handleLoyaltyClick()
  } else {
    goToStep(true)
  }

  send('segment', 'loyalty:type:clicked', {
    type: type
  })
}

const hardwarelessCardImage = computed(() => `${import.meta.env.VITE_AWS_STORAGE_URL}/loyalty/fid_sans_contact.png`)
const tabletCardImage = computed(() => `${import.meta.env.VITE_AWS_STORAGE_URL}/loyalty/fid_tablette_c.png`)
</script>

<template>
  <LoyaltyCreateContainer content-type="centered">
    <div class="flex flex-col items-center justify-center gap-12 md:flex-row">
      <LoyaltyCreateGradientCard
        :title="t('pages.loyalty.create.magicScan')"
        :image="hardwarelessCardImage"
        @click="handleClick('hardwareless')"
      >
        {{ t('pages.loyalty.create.magicScanDescription') }}
      </LoyaltyCreateGradientCard>

      <LoyaltyCreateGradientCard
        :title="t('pages.loyalty.create.tablet')"
        :image="tabletCardImage"
        @click="handleClick('tablet')"
      >
        {{ t('pages.loyalty.create.tabletDescription') }}
      </LoyaltyCreateGradientCard>
    </div>
  </LoyaltyCreateContainer>
</template>
